<template>
    <action>
        <template v-slot:header>
            Zeige Freunde/Kollegen auf der Karte an
        </template>

        <toggle-group v-model="hasFriendsOnMap" v-show="!loading">
            Zeige Freunde auf der Karte an
        </toggle-group>

        <loading v-show="loading"></loading>

        <template v-slot:action v-show="!loading">
            <button-primary @click="save">
                <i class="fa fa-save"></i> Speichern
            </button-primary>
        </template>
    </action>
</template>

<script>
import Action from "../UI/Action";
import ToggleGroup from "../UI/ToggleGroup.vue";
import Loading from "../UI/Loading.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";

export default {
    name: "HasFriendsOnMap",

    components: {
        ButtonPrimary,
        Loading,
        ToggleGroup,
        Action,
    },

    inject: ['group'],

    data: () => ({
        hasFriendsOnMap: false,
        loading: false,
    }),

    created() {
        this.hasFriendsOnMap = this.group.has_friends_on_map;
    },

    methods: {
        save() {
            this.loading = true;
            this.$http.post('/admin/group', {
                has_friends_on_map: this.hasFriendsOnMap,
            }).then(() => {
                this.loading = false;
                this.$root.$emit('alert', 'Gespeichert');
            }).catch((error) => {
                this.loading = false;
                location.reload();
            })
        },
    }
}
</script>

<style scoped>

</style>
